<script>

    import { replace } from 'svelte-spa-router'
    import { toast } from 'bulma-toast'

    import { ordersStore, modalStore } from '../stores'

    import OrdersService from '../$services/orders.service'
    import DateMethod from '../$methods/date.methods'
    import Delete from '../$components/delete.svelte'
    import Switch from '../$components/switch.svelte'

    const { BRAND } = _CONSTANTS_

    export let order = null

    let loading = false
    let localService = false

    async function deleteOrder() {

        loading = true
        const resp = await OrdersService.deleteOrder(order._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        ordersStore.remove(order._id)
        modalStore.close()
        toast({message: 'Órden borrada', type: 'is-success'})
    }

    async function openOrder(def='') {
        modalStore.close()
        replace(`#/order/${def}?localServices=${localService}`)
    }

    function logJSON(obj) {
        console.log(JSON.stringify(obj, null, 4))
    }

</script>


<div class="columns">
    <div class="column">
        <div class="title">Orden #{ order.number }</div>
        <div class="subtitle">{ DateMethod.dateTimeLarge(order.created) }</div>
    </div>
</div>

{#if order.shipmentId}
    <div class="columns">
        <div class="column">
            <div class="title">El envío ya fue generado</div>
            <div class="subtitle">Guía { order.shipment.guide }</div>
        </div>
    </div>
{/if}

<div class="columns">

    {#if order.pickup}
        <div class="column" on:dblclick={() => logJSON(order.pickup)}>
            <div class="title">Origen</div>
            <div><b>{ order.pickup.contact }</b></div>
            <div>{ order.pickup.rfc || 'Sin información' }</div>
            <div>{ order.pickup.corporate || 'Sin información' }</div>
            <div>{ order.pickup.phone }</div>
            <div>{ order.pickup.email }</div>
            <div>{ order.pickup.street }</div>
            <div>{ order.pickup.number }, { order.pickup.apartment || '' }</div>
            <div>{ order.pickup.colony }</div>
            <div><b>{ order.pickup.zipcode }</b>, { order.pickup.city }, { order.pickup.state }</div>
            <div>{ order.pickup.references }</div>

            {#if order.storeType === BRAND}
                <div class="items-end">
                    <button on:click={() => modalStore.set('order_update_pickup_modal') } class="button space-top">
                        <span class="icon"><i class="fas fa-edit"></i></span>
                        <span>Editar</span>
                    </button>
                </div>
            {/if}
        </div>
        <div class="is-divider-vertical"></div>
    {/if}

    <div class="column" on:dblclick={() => logJSON(order.delivery)}>
        <div class="title">Destino</div>
        <div><b>{ order.delivery.contact }</b></div>
        <div>{ order.delivery.rfc || 'Sin información' }</div>
        <div>{ order.delivery.corporate || 'Sin información' }</div>
        <div>{ order.delivery.phone }</div>
        <div>{ order.delivery.email }</div>
        <div>{ order.delivery.street }</div>
        <div>{ order.delivery.number }, { order.delivery.apartment || '' }</div>
        <div>{ order.delivery.colony }</div>
        <div><b>{ order.delivery.zipcode }</b> { order.delivery.municipality || '' }, { order.delivery.city }, { order.delivery.state }</div>
        <div>{ order.delivery.references }</div>

        {#if order.storeType === BRAND}
            <div class="items-end">
                <button on:click={() => modalStore.set('order_update_delivery_modal') } class="button space-top">
                    <span class="icon"><i class="fas fa-edit"></i></span>
                    <span>Editar</span>
                </button>
            </div>
        {/if}
    </div>
</div>

<div class="columns">
    {#if order.package}
        <div class="column" on:dblclick={() => logJSON(order.package)}>
            <div class="title">Paquete</div>
            <div>{ order.package.width }cm x { order.package.height }cm x { order.package.length}cm </div>
            <div>{ order.package.weight }Kg físico</div>
            {#if order.storeType === BRAND}
                <div class="items-end">
                    <button on:click={() => modalStore.set('order_update_package_modal') } class="button space-top">
                        <span class="icon"><i class="fas fa-edit"></i></span>
                        <span>Editar</span>
                    </button>
                </div>
            {/if}
        </div>
        <div class="is-divider-vertical"></div>
        <div class="column">
            <div class="title">Contenido</div>
            <div>Valor declarado ${ order.package.value }</div>
            <div>{ order.package.content }</div>
        </div>
    {/if}
</div>

{#if order.quotation && order.quotation.provider}
    <div class="columns">
        <div class="column" on:dblclick={() => logJSON(order.quotation)}>
            <div class="title">Proveedor</div>
            <div class="items-space">
                <div><img class="provider-image" src="images/{order.quotation.provider.replace(' Partner', '')}.svg" alt=""></div>
                <div>{order.quotation.service}</div>
                <div><b>${order.quotation.finalPrice}</b></div>
            </div>
        </div>
    </div>
{/if}

{#if order.service}
    <div class="columns">
        <div class="column">
            <div class="title">Servicio</div>
            {#if order.service.code}
                <div>{ order.service.code }</div>
            {/if}
            {#if order.service.price}
                <div>Precio ${ order.service.price }</div>
            {/if}
        </div>
    </div>
{/if}

{#if order.products.length}
    <div class="columns">
        <div class="column">
            <div class="title">Productos</div>
            <div class="table-container">
                <table class="table is-fullwidth is-hoverable">
                    <thead>
                        <tr>
                            <th></th>
                            <th>SKU</th>
                            <th>Nombre</th>
                            <th>Precio</th>
                            <th>Cantidad</th>
                        </tr>
                    </thead>
                    <tbody>
                    {#each order.products as product, index}
                        <tr>
                            <td>{ index+1 }</td>
                            <td>{ product.sku }</td>
                            <td>{ product.name }</td>
                            <td>${ product.price }</td>
                            <td>{ product.quantity }</td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
{/if}

<div class="items-end">
    <div class="buttons">
        {#if order.storeType === BRAND}
            <Delete on:confirm={deleteOrder} {loading} />
        {/if}
        {#if !order.shipment}
            <button on:click={() => openOrder()} class="button is-primary">
                <span class="icon"><i class="fas fa-shipping-fast"></i></span>
                <span>Revisar y envíar</span>
            </button>
        {/if}
    </div>
</div>